import axios from "axios";
import store from '../index';

export default {
    namespaced: true,
    state: {
        conditions: {
            keyword: '',
            scope: '',
            hierarchy: true,
        },
        hasHierarchySearched: false,
        total: 0,
        pageNo: 1,
        pageSize: 10,
        sort: [],
        keywordScope: [
            {
                text: '제목',
                value: "title",
            },
            {
                text: '제목/내용',
                value: "title/content",
            },
            {
                text: '작성자',
                value: "creator",
            },
        ],
        tableColumns: [
            { name: 'id', sort: '', width: "6.811%" },
            { name: 'title', sort: '', width: "60.434%" },
            { name: 'creator', sort: '', width: "8.695%" },
            { name: 'creationDate', sort: '', width: "10.362%" },
            { name: 'updater', sort: '', width: "8.695%" },
            { name: 'updatedDate', sort: '', width: "10.362%" },
        ],
    },
    getters: {
        conditions(state) {
            return state.conditions;
        },
        currentPageNo(state) {
            return state.pageNo;
        },
        pageSize(state) {
            return state.pageSize;
        },
        total(state) {
            return state.total;
        },
        keywordScope(state) {
            return state.keywordScope;
        },
        sort(state) {
        return state.tableColumns
            .filter(col => col.sort)
            .map(col => ({
            field: col.name,
            direction: col.sort
            }))
        },
        tableColumns(state) {
            return state.tableColumns;
        },
        hasHierarchySearched(state) {
            return state.hasHierarchySearched;
        }
    },
    mutations: {
        setKeyword(state, keyword) {
            state.conditions.keyword = keyword;
        },
        setScope(state, scope) {
            state.conditions.scope = scope.value;
        },
        setPageNo(state, pageNo) {
            state.pageNo = pageNo;
        },
        setTotal(state, total) {
            state.total = total;
        },
        setSort(state, columnName) {
            state.tableColumns.forEach(column => {
                if(column.name === columnName) {
                    column.sort = ({
                        '': 'ASC',
                        ASC: 'DESC',
                        DESC: ''
                    })[column.sort];
                }
            })
        },
        setHasHierarchySearched(state, value) {
            state.hasHierarchySearched = value;
        }
    }

}